import React from 'react';
import { Check, ArrowRight, Users, Clock, Presentation, Wifi, Zap, PenTool } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function BetterOnlineWorkshops() {
  const {
    t
  } = useLanguage();
  const benefits = t('betterOnlineWorkshops.benefits') as string[];
  const sessions = t('betterOnlineWorkshops.sessions') as Array<{
    title: string;
    desc: string;
    topics: string[];
    isHomework?: boolean;
  }>;
  const forWhomItems = t('betterOnlineWorkshops.forWhomItems') as string[];
  const forWhomIcons = [<Presentation className="text-purple-600 shrink-0" size={20} data-id="element-552" data-mp="32ya2s4b5old2" />, <Zap className="text-purple-600 shrink-0" size={20} data-id="element-553" data-mp="32vxny00p2r48" />, <Users className="text-purple-600 shrink-0" size={20} data-id="element-554" data-mp="21dm7wuw54owk" />, <PenTool className="text-purple-600 shrink-0" size={20} data-id="element-555" data-mp="26d8i0vgo9p15" />];
  return <PageTransition data-id="element-556" data-mp="26b5npz8hl9qm">
      <div className="pt-12 pb-24" data-id="element-557" data-mp="2b3oy6nbvnor7">
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-558" data-mp="2b5i94etiwv50">
          <DecorativeShape type="circle" color="bg-purple-100" className="top-0 right-0 w-[400px] h-[400px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-559" data-mp="2f4r0jd13cgxe" />
          <DecorativeShape type="blob" color="bg-fuchsia-100" className="bottom-0 left-0 w-64 h-64 -translate-x-1/4 translate-y-1/4 -z-10" data-id="element-560" data-mp="1nfnvhv1dr2jp" />
          <Animate className="text-center max-w-4xl mx-auto" data-id="element-561" data-mp="1wfkp8b2mmrlm">
            <span className="inline-block px-4 py-2 bg-purple-50 text-purple-600 font-medium rounded-full text-sm mb-6" data-id="element-562" data-mp="1wcy7jim0uvpo">
              {t('betterOnlineWorkshops.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-563" data-mp="37wkeextogqbf">
              {t('betterOnlineWorkshops.title')} <br data-id="element-564" data-mp="13qmwuri41s78" />
              <span className="text-purple-600" data-id="element-565" data-mp="13r63vd682w6h">
                {t('betterOnlineWorkshops.titleHighlight')}
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-566" data-mp="1hpw3p0kff9yj">
              {t('betterOnlineWorkshops.subtitle')}
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-500 mb-10" data-id="element-567" data-mp="p1qi6bljtgxn">
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-568" data-mp="k2xd97kbuy93">
                <Clock size={18} className="text-purple-600" data-id="element-569" data-mp="yrtlb4mdwb9p" />
                <span data-id="element-570" data-mp="u0tl9qhyxd2z">{t('betterOnlineWorkshops.duration')}</span>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-571" data-mp="tyqp0oq82npt">
                <Presentation size={18} className="text-purple-600" data-id="element-572" data-mp="1cflp6b8e8pb" />
                <span data-id="element-573" data-mp="1a1uj8jo9gn1">{t('betterOnlineWorkshops.audience')}</span>
              </div>
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-574" data-mp="2cxy7gltwp8g3">
                <Wifi size={18} className="text-purple-600" data-id="element-575" data-mp="2hs2j3ie4a4ni" />
                <span data-id="element-576" data-mp="2404dvinj0swm">{t('betterOnlineWorkshops.online')}</span>
              </div>
            </div>
            <Link to="/contact" data-id="element-577" data-mp="2817w2bt1r110">
              <Button className="bg-purple-600 hover:bg-purple-700 text-white shadow-purple-200" size="lg" rightIcon={<ArrowRight size={20} data-id="element-579" data-mp="30o0ycym348d4" />} data-id="element-578" data-mp="27y25st8olt3p">
                {t('betterOnlineWorkshops.bookCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-24" data-id="element-580" data-mp="2rnmcny57kr93">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-581" data-mp="1ba5otn9c0vry">
            <div className="lg:col-span-2 space-y-12" data-id="element-582" data-mp="1b8uipgsezbxo">
              <Animate data-id="element-583" data-mp="1g9iiaqupl13i">
                <h2 className="text-3xl font-bold mb-6 text-charcoal" data-id="element-584" data-mp="1gatn8tzw4ew7">
                  {t('betterOnlineWorkshops.aboutTitle')}
                </h2>
                <div className="prose prose-lg text-gray-600" data-id="element-585" data-mp="1qsfb55vvfqxg">
                  <p className="mb-4" data-id="element-586" data-mp="1qquhdihdsc0n">{t('betterOnlineWorkshops.aboutP1')}</p>
                  <p data-id="element-587" data-mp="1ltvpz7p3qj65">{t('betterOnlineWorkshops.aboutP2')}</p>
                </div>
              </Animate>
              <Animate delay={0.1} data-id="element-588" data-mp="1ht20i9w0gwb5">
                <h3 className="text-2xl font-bold mb-6 text-charcoal" data-id="element-589" data-mp="1hpnzb4z32t5a">
                  {t('betterOnlineWorkshops.learnTitle')}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-590" data-mp="29jyddai2n0yf">
                  {benefits.map((benefit: string, index: number) => <div key={index} className="flex items-start gap-3" data-id="element-591" data-mp="25iwckp8iaguc" data-mpi={index}>
                      <div className="mt-1 p-1 rounded-full bg-purple-50 text-purple-600 flex-shrink-0" data-id="element-592" data-mp="20hp38lqpt9lk">
                        <Check size={14} strokeWidth={3} data-id="element-593" data-mp="u37lblo7yvnq" />
                      </div>
                      <span className="text-gray-700" data-id="element-594" data-mp="p18lglrougvj">{benefit}</span>
                    </div>)}
                </div>
              </Animate>
              <Animate delay={0.15} data-id="element-595" data-mp="35oqdbixhmrmy">
                <h3 className="text-2xl font-bold mb-6 text-charcoal" data-id="element-596" data-mp="35prmfhuy1421">
                  {t('betterOnlineWorkshops.structureTitle')}
                </h3>
                <div className="space-y-6" data-id="element-597" data-mp="3ehbk00nuh7vf">
                  {sessions.map((session, index) => <Card key={index} className={`p-6 border-l-4 ${session.isHomework ? 'border-yellow-400 bg-yellow-50' : 'border-purple-600 bg-white'}`} data-id="element-598" data-mp="3jh67rvcbphc9" data-mpi={index}>
                      <div className="flex items-start justify-between mb-2" data-id="element-599" data-mp="3tfvsrwzinhwq">
                        <h4 className="text-xl font-bold text-charcoal" data-id="element-600" data-mp="1bjq79fh7957">
                          {session.title}
                        </h4>
                        {session.isHomework && <span className="bg-yellow-200 text-yellow-800 text-xs font-bold px-2 py-1 rounded-full" data-id="element-601" data-mp="231v6ssbf2y1l">
                            {t('betterOnlineWorkshops.homework')}
                          </span>}
                      </div>
                      <p className="text-gray-600 mb-4" data-id="element-602" data-mp="31gbsrtyaofio">{session.desc}</p>
                      <div className={`${session.isHomework ? 'bg-white' : 'bg-purple-50'} p-4 rounded-xl`} data-id="element-603" data-mp="3ffjyl5oyqlvu">
                        <p className={`text-sm font-bold ${session.isHomework ? 'text-yellow-800' : 'text-purple-800'} mb-2`} data-id="element-604" data-mp="3pbmye4wce8fm">
                          {t('betterOnlineWorkshops.topicsLabel')}
                        </p>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-605" data-mp="2yen05sznwz7">
                          {session.topics.map((topic: string, i: number) => <li key={i} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-606" data-mp="by1rx1kxfkx0" data-mpi={i}>
                              <div className={`w-1.5 h-1.5 rounded-full ${session.isHomework ? 'bg-yellow-500' : 'bg-purple-600'}`} data-id="element-607" data-mp="ql0h0pwba38k" />
                              {topic}
                            </li>)}
                        </ul>
                      </div>
                    </Card>)}
                </div>
              </Animate>
            </div>
            <div className="lg:col-span-1" data-id="element-608" data-mp="ck7htrv2ejz4">
              <div className="sticky top-24 space-y-8" data-id="element-609" data-mp="cl93srdmcqvm">
                <Card className="p-8 bg-white shadow-xl border-t-4 border-purple-600" data-id="element-610" data-mp="3u0phfftnclzx">
                  <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-611" data-mp="3tyuszrj62br3">
                    {t('betterOnlineWorkshops.forWhom')}
                  </h3>
                  <ul className="space-y-4 mb-8" data-id="element-612" data-mp="3l12f8rt3fc5t">
                    {forWhomItems.map((item: string, i: number) => <li key={i} className="flex items-start gap-3" data-id="element-613" data-mp="3pyav2lqrr43w" data-mpi={i}>
                        {forWhomIcons[i]}
                        <span className="text-gray-600" data-id="element-614" data-mp="99n19ex99dgr">{item}</span>
                      </li>)}
                  </ul>
                  <Link to="/contact" className="block" data-id="element-615" data-mp="3vieilvmst98r">
                    <Button className="w-full bg-purple-600 hover:bg-purple-700 text-white shadow-purple-200" rightIcon={<ArrowRight size={18} data-id="element-617" data-mp="3mij4bhxy4y4i" />} data-id="element-616" data-mp="3vl0pru5s1mqg">
                      {t('betterOnlineWorkshops.inquiry')}
                    </Button>
                  </Link>
                </Card>
                <div className="bg-purple-50 rounded-3xl p-8 text-center" data-id="element-618" data-mp="3croigeom40jl">
                  <div className="w-16 h-16 mx-auto bg-white rounded-full flex items-center justify-center shadow-md mb-4 text-purple-600" data-id="element-619" data-mp="37tmyzsn9xz7l">
                    <Users size={32} data-id="element-620" data-mp="33qgk5wm3izpi" />
                  </div>
                  <h4 className="font-bold text-lg mb-2" data-id="element-621" data-mp="2ysx7h151quzo">
                    {t('betterOnlineWorkshops.groupTitle')}
                  </h4>
                  <p className="text-gray-600 text-sm mb-4" data-id="element-622" data-mp="1e9urjue7x164">
                    {t('betterOnlineWorkshops.groupDesc')}
                  </p>
                  <Link to="/contact" className="text-purple-600 font-bold hover:underline" data-id="element-623" data-mp="1nbb2q4cux7be">
                    {t('betterOnlineWorkshops.contactLink')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-624" data-mp="zl89vm14bxbq">
          <Animate data-id="element-625" data-mp="zjdok6lxq374">
            <Card className="p-12 bg-gradient-to-br from-purple-50 to-fuchsia-50 border-0" data-id="element-626" data-mp="14l315qot2oxb">
              <h2 className="text-3xl font-bold mb-4" data-id="element-627" data-mp="19b9qjsr56dgm">
                {t('betterOnlineWorkshops.ctaTitle')}
              </h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-628" data-mp="bv4ajquyqjqj">
                {t('betterOnlineWorkshops.ctaDesc')}
              </p>
              <Link to="/contact" data-id="element-629" data-mp="gtfh9spyoe4j">
                <Button className="bg-purple-600 hover:bg-purple-700 text-white shadow-purple-200" rightIcon={<ArrowRight size={18} data-id="element-631" data-mp="3928tqinb5l3x" />} data-id="element-630" data-mp="351yk8w0b4ckb">
                  {t('betterOnlineWorkshops.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}